import React, { FC } from 'react';
import { makeStyles, SvgIcon, Typography } from '@material-ui/core';
import { SVGIcon } from 'types/common.types';

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: '20px',
    lineHeight: '0',
    color: 'inherit',
  },
}));

interface ISidebarIcon {
  icon: SVGIcon;
  iconViewBox?: string;
}

const SidebarIcon: FC<ISidebarIcon> = ({ icon, iconViewBox }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.icon}>
      <SvgIcon fontSize="inherit" component={icon} viewBox={iconViewBox} />
    </Typography>
  );
};

export default SidebarIcon;
